/*eslint-disable*/
import { CancelBtn } from 'components/Button/CancelBtn'
import { Input } from 'components/Input/Input'
import { toast } from 'react-toastify'
import { Animation, Button, ButtonsContainer, Flex, TabFooter } from 'styling/GlobalStyles'
import { IEmployeesTabWithValidation } from 'types/users.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { standardFieldValidation } from 'utils/validationUtils'

export const EmployeeBankInfoTab = ({
    handleSubmit,
    state,
    setState,
    invalidFields,
    setInvalidFields
}: IEmployeesTabWithValidation) => {
    useFocusFirstInput()
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target
        if (!['branchCode', 'ssnit'].includes(name)) {
            standardFieldValidation(e, setInvalidFields)
        }
        setState(prev => ({ ...prev, bankInfo: { ...prev.bankInfo, [name]: value } }))
    }

    const handleSave = () => {
        if (invalidFields.length) {
            toast.warn('All fields must be valid')
            return
        }
        handleSubmit()
    }


    return <Animation>
        <Flex column width='30%' gap='1rem'>
            <Input name='ssnit' labelText='SSNIT' onChange={handleChange} value={state?.bankInfo?.ssnit} placeholder='123456...' nomarg />
            <Input name='bankName' labelText='Bank Name' onChange={handleChange} value={state?.bankInfo?.bankName} placeholder='First national bank' nomarg invalid={invalidFields.includes('bankName')} required />
            <Input name='branchCode' labelText='Branch Code' onChange={handleChange} value={state?.bankInfo?.branchCode} placeholder='LD484' nomarg />
            <Input name='accountNumber' labelText='Account Number' onChange={handleChange} value={state?.bankInfo?.accountNumber} placeholder='123-456-56' nomarg invalid={invalidFields.includes('accountNumber')} required />
        </Flex>
        <TabFooter>
            <ButtonsContainer>
                <CancelBtn />
                <Button type='button' onClick={handleSave} orange>
                    Save
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>
}